import { Pipe, PipeTransform } from '@angular/core';

import { I18nService } from '@localize/services/';

@Pipe({
	name: 'i18nString'
})
export class I18nStringPipe implements PipeTransform {
	constructor(private i18nService: I18nService) {}

	transform(fallback: string, key: string): string {
		return this.i18nService.get(fallback, key);
	}
}
